<ng-container *ngIf="hasData; else emptyDimension">
  <po-info
    *ngIf="isTruncated"
    p-label="Exibindo"
    [p-value]="chartNote"
    p-orientation="horizontal">
  </po-info>

  <po-chart
    [p-type]="barType"
    [p-categories]="categories"
    [p-series]="series"
    [p-options]="chartOptions"
    [p-height]="Math.max(160, categories.length * 36 + 90)">
  </po-chart>

  <!-- À direita, como "Ver todos" das ações e "Ver ranking completo". -->
  <div class="breakdown__footer" *ngIf="isTruncated">
    <po-button
      [p-label]="toggleLabel"
      p-kind="secondary"
      p-icon="po-icon po-icon-list"
      (p-click)="openAll()">
    </po-button>
  </div>
</ng-container>

<ng-template #emptyDimension>
  <p class="po-font-text-small">Sem dados neste período.</p>
</ng-template>

<po-modal [p-title]="modalTitle" p-size="xl" p-click-out="true" [p-primary-action]="closeAction"
  (p-close)="expanded = false">
  <ng-container *ngIf="expanded">
    <div class="breakdown-modal__toolbar">
      <p class="po-font-text-small breakdown-modal__summary">
        {{ search ? searchNote : modalSummary }}
      </p>
      <po-search
        class="breakdown-modal__search"
        p-aria-label="Pesquisar na lista"
        p-search-type="trigger"
        [p-literals]="searchLiterals"
        (p-change-model)="onSearch($event)">
      </po-search>
    </div>

    <po-table
      *ngIf="visibleRows.length; else noMatch"
      class="breakdown-modal__table"
      [p-columns]="columns"
      [p-items]="visibleRows"
      [p-striped]="true"
      [p-hide-table-search]="true"
      [p-hide-columns-manager]="true">
      <ng-template p-table-column-template [p-property]="'volume'" let-value>
        <div class="breakdown-volume">
          <div class="breakdown-volume__track" aria-hidden="true">
            <div class="breakdown-volume__fill" [style.width.%]="value.width"></div>
          </div>
          <span class="breakdown-volume__count">{{ value.reviews }}</span>
          <span class="breakdown-volume__share">{{ value.share }}</span>
        </div>
      </ng-template>
    </po-table>

    <ng-template #noMatch>
      <p class="po-font-text-small">Nada encontrado para "{{ search }}".</p>
    </ng-template>
  </ng-container>
</po-modal>
